import {icons,restartConfigurator,sectionSettings} from "../../Helpers/WindowHelpers";
import parse from 'html-react-parser';

interface StartOverButtonInterface {
  classes?: string
}

const StartOverButton = ({ classes }: StartOverButtonInterface) => {
  return <button className={`configurator-view__restart ${classes || ''}`} onClick={restartConfigurator} type="button">
      <span>{parse(icons.caretLeft ?? '')}</span>
      <span className="link">{sectionSettings.label_start_over}</span>
  </button>
}

export default StartOverButton